import { EnvironmentConfig } from "@shared/src/lib/models/global";

export const environment: EnvironmentConfig = {
	production: true,
	env: 'production',
	sentryEnabled: true,
	apiUrl: "https://production.jailhousemail.com/"
};
